import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axiosInstance from "../components/axiosInstance"; // Adjust this path if needed
import { clear_session, user_created_success } from "../redux";

export const Logout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (reason = null) => {
        const refreshToken = localStorage.getItem("refreshToken");

        // 1. Safety Gate: If no token exists, just clear local state and redirect
        if (!refreshToken || refreshToken === "null" || refreshToken === "undefined") {
            dispatch(clear_session());
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            navigate("/shop/login");
            return;
        }

        // 2. Fire the secure POST request to the backend blacklist table
        axiosInstance
            .post("users/logout/", { refresh: refreshToken })
            .then((response) => {
                if (response.data?.ok) {
                    console.log("Server logout successful");
                }
            })
            .catch((error) => {
                console.error("Backend logout failed, clearing locally anyway:", error);
            })
            .finally(() => {
                // 3. Always run this, whether the network call succeeds or fails
                dispatch(clear_session());
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");

                if (reason) {
                    dispatch(user_created_success(reason))
                }

                navigate("/shop/login");
            });
    };

};